import { LOGIN_SUCCESS, LOGOUT } from '../actions/authActions';

const initialState = {
  isAuthenticated: false,
  token: null,
  user: null,
};

const token = localStorage.getItem('token');
if (token) {
  const user = JSON.parse(atob(token.split('.')[1]));
  initialState.isAuthenticated = true;
  initialState.token = token;
  initialState.user = user;
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        isAuthenticated: true,
        token: action.payload.token,
        user: action.payload.user,
      };
    case LOGOUT:
      return {
        isAuthenticated: false,
        token: null,
        user: null,
      };
    default:
      return state;
  }
};

export default authReducer;
